import useHashLocation from './useHashLocation';

export default function useHashParamFeatureFlag(featureFlag: string): boolean {
  const hashLocation = useHashLocation();
  const featureFlagValue = hashLocation.values[featureFlag] === 'true';

  return featureFlagValue;
}
